import { CardWithSwitch } from 'app/pages/repairOrders/components';
import { useFormikContext } from 'formik';
import { IQuickVideoForm } from 'lib/api/quickVideo/types';
import { Gap } from 'lib/components/styles/layout';
import React from 'react';
import { Typography } from 'react-covideo-common';
import { CustomizeEmailContent } from './CustomizeEmailContent';
import { CustomizeSMSContent } from './CustomizeSMSContent';
import { useTranslation } from 'react-i18next';

export const CustomizeEmailSmsComponent = () => {
  const { t } = useTranslation();
  const { values } = useFormikContext<IQuickVideoForm>();

  if (values.generateEmailSmsContent) {
    return (
      <Gap width='100%' justifyContent='center' m='40px 0'>
        <Typography variant='normal' fontWeight={400}>
          {t('The Email and SMS script templates will be generated by AI.')}
        </Typography>
      </Gap>
    );
  }
  return (
    <Gap width='100%' flexDirection='column' m='10px 0 0 0'>
      <CardWithSwitch
        hideSwitch
        switchId='quickVideoSendEmail'
        switchIsOn={true}
        switchDisabled={false}
        handleToggle={() => {}}
        title={t('Email Template')}
        text={''}
        expandedDefault
        extendStyles={{
          card: {
            width: '100%',
            boxSizing: 'border-box',
          },
        }}
        expandedContent={<CustomizeEmailContent />}
      />

      <CardWithSwitch
        hideSwitch
        switchId='quickVideoSendSMS'
        switchIsOn={true}
        switchDisabled={false}
        handleToggle={() => {}}
        title={t('SMS Template')}
        text=''
        expandedDefault
        expandedContent={<CustomizeSMSContent />}
      />
    </Gap>
  );
};
